import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSessionStatus implements BaseEnumType {
  private static allValues: EnumSessionStatus[] = []; // make sure this is top-most
  
  public static none = new EnumSessionStatus(0, "None", "enum_session_status_none");
  public static allSessionsUsed = new EnumSessionStatus(1, "AllSessionsUsed", "enum_session_status_all_sessions_used");
  public static billingNotValid = new EnumSessionStatus(2, "BillingNotValid", "enum_session_status_billing_not_valid");
  public static success = new EnumSessionStatus(3, "Success", "enum_session_status_success");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSessionStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumSessionStatus.none; }
  public isAllSessionsUsed() { return this === EnumSessionStatus.allSessionsUsed; }
  public isBillingNotValid() { return this === EnumSessionStatus.billingNotValid; }
  public isSuccess() { return this === EnumSessionStatus.success; }

  public static getValues(): readonly EnumSessionStatus[] {
    return EnumSessionStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumSessionStatus[] {
    return EnumSessionStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSessionStatus {
    const found = EnumSessionStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSessionStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSessionStatus): EnumSessionStatus {
    const found = name ? EnumSessionStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSessionStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSessionStatus>): boolean {
    return this.key === other?.key;
  }
}